export default __webpack_public_path__ + "static/media/bu-fauziah.2fa59112.png";